import { render, staticRenderFns } from "./DocumentViewModal.vue?vue&type=template&id=a125a726&scoped=true&"
import script from "./DocumentViewModal.vue?vue&type=script&lang=js&"
export * from "./DocumentViewModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentViewModal.vue?vue&type=style&index=0&id=a125a726&prod&scoped=true&lang=css&"
import style1 from "./DocumentViewModal.vue?vue&type=style&index=1&id=a125a726&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a125a726",
  null
  
)

export default component.exports